"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theme = require("../theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  getBaseStyle: function getBaseStyle(props) {
    var theme = props.theme,
        color = props.color,
        fontColor = props.fontColor,
        inverse = props.inverse,
        _props$size = props.size,
        size = _props$size === void 0 ? 'medium' : _props$size,
        disabled = props.disabled,
        ghost = props.ghost,
        minimal = props.minimal,
        shape = props.shape;
    var componentStyles = theme.components.button;
    var primary = inverse || minimal ? fontColor : color;
    var secondary = inverse || minimal ? color : fontColor;
    var circle = shape === 'circle';
    var options = {
      primary: theme.palette[primary],
      secondary: theme.palette[secondary],
      inverse: inverse,
      minimal: minimal,
      disabled: disabled,
      circle: circle
    };
    var defaultStyles = componentStyles.defaults(options) || {};
    var sizeStyles = componentStyles.sizes[size];
    var disabledStyles = disabled ? componentStyles.disabled(options) : {};
    var inverseStyles = inverse ? componentStyles.inverse(options) : {};
    var linkStyled = minimal ? componentStyles.minimal(options) : {};
    var ghostStyles = ghost ? componentStyles.ghost(options) : {};
    return _objectSpread({}, defaultStyles, {}, sizeStyles, {}, inverseStyles, {}, linkStyled, {}, disabledStyles, {}, ghostStyles);
  },
  getBlockStyle: function getBlockStyle(_ref) {
    var fullWidth = _ref.fullWidth;
    return fullWidth && {
      width: '100%'
    };
  },
  getCircleButtonStyle: function getCircleButtonStyle(_ref2) {
    var theme = _ref2.theme,
        shape = _ref2.shape,
        _ref2$size = _ref2.size,
        size = _ref2$size === void 0 ? 'medium' : _ref2$size;
    return shape === 'circle' ? {
      paddingLeft: 0,
      paddingRight: 0,
      height: theme.components.button.circle[size],
      width: theme.components.button.circle[size]
    } : null;
  },
  getDefaultFocusstyles: function getDefaultFocusstyles() {
    var _ref3;

    return _ref3 = {
      // this effectively is clearing anything the browser doesn't clear up properly
      boxShadow: "0 0 0 0 transparent",
      transition: 'box-shadow 0.2s ease-in-out'
    }, (0, _defineProperty2.default)(_ref3, '::-moz-focus-inner', {
      border: 0
    }), (0, _defineProperty2.default)(_ref3, ':focus', {
      /* Visible in Windows high-contrast themes */
      outlineColor: 'transparent',
      outlineWidth: 2,
      outlineStyle: 'dotted'
    }), _ref3;
  },
  getFocusStyles: function getFocusStyles(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? 'ctaPrimary' : _ref4$color,
        _ref4$disabled = _ref4.disabled,
        disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
        _ref4$focusIndicatorS = _ref4.focusIndicatorSize,
        focusIndicatorSize = _ref4$focusIndicatorS === void 0 ? 'medium' : _ref4$focusIndicatorS,
        _ref4$fontColor = _ref4.fontColor,
        fontColor = _ref4$fontColor === void 0 ? 'light' : _ref4$fontColor,
        _ref4$minimal = _ref4.minimal,
        minimal = _ref4$minimal === void 0 ? false : _ref4$minimal,
        theme = _ref4.theme;
    var palette = theme.palette;
    var innerRingSize = 2;

    if (focusIndicatorSize === 'small') {
      innerRingSize = 1;
    }

    var outerRingSize = innerRingSize * 2;

    if (disabled) {
      return {};
    }

    if (minimal) {
      var _ref5;

      return _ref5 = {
        boxShadow: "inset 0 0 0 0 transparent"
      }, (0, _defineProperty2.default)(_ref5, ':hover', {
        background: (0, _theme.transparentize)(0.9, palette[color])
      }), (0, _defineProperty2.default)(_ref5, ':focus', (0, _defineProperty2.default)({
        background: 'transparent',
        boxShadow: "inset 0 0 0 ".concat(innerRingSize, "px ").concat(palette[color])
      }, ':hover', {
        background: (0, _theme.transparentize)(0.9, palette[color])
      })), _ref5;
    }

    return (0, _defineProperty2.default)({}, ':focus', {
      boxShadow: "0 0 0 ".concat(innerRingSize, "pt ").concat(palette[fontColor], ", 0 0 0 ").concat(outerRingSize, "pt ").concat(palette[color])
    });
  }
};
var _default = styles;
exports.default = _default;